<template>
  <div class="h-full bg-zinc-900">
    <div class="h-full">
      <div class="min-h-screen m-auto max-w-3xl flex flex-col justify-center items-center">
        <RouterView/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

onMounted(() => {
  const body = document.getElementById("body");

  body?.classList.add("bg-zinc-900");
  body?.classList.remove("bg-white");
});
</script>